<template>
  <a-modal
    title="云学谷用户隐私政策"
    style="top: 20px;"
    :width="1200"
    v-model="vable"
    @ok="handleOk"
  >
    <div class="page-header-index-wide" style="line-height:25px; ">
      <div>&emsp;&emsp;北京腾骏英才教育科技有限公司（下称“我们”或“公司”）尊重并保护用户隐私，在您使用云学谷APP平台或WEB（以下简称“云学谷”）提供的服务时，我们除了按照《云学谷用户服务协议》的约定向您提供服务外，我们还将按照《云学谷用户隐私政策》（以下简称“本隐私政策”）收集、使用您的个人信息。</div>
      <div>&emsp;&emsp;请您仔细阅读本隐私政策的全部条款以便您了解云学谷收集、使用您个人信息的目的、范围、方式等。如果您为未成年人，则您应在法定监护人陪同下审阅本隐私政策，经法定监护人审阅并同意后，您方可使用云学谷并向云学谷提供个人信息。如果您或监护人不同意本隐私政策任何内容，您应立即停止使用云学谷产品或服务。当您使用云学谷提供的任一服务时，即表示您已同意我们按照本隐私政策来收集、使用、存储和保护您的相关信息。</div>
      <div>&emsp;&emsp;请您仔细阅读本隐私政策的全部条款以便您了解云学谷收集、使用您个人信息的目的、范围、方式等。如果您为未成年人，则您应在法定监护人陪同下审阅本隐私政策，经法定监护人审阅并同意后，您方可使用云学谷并向云学谷提供个人信息。如果您或监护人不同意本隐私政策任何内容，您应立即停止使用云学谷产品或服务。当您使用云学谷提供的任一服务时，即表示您已同意我们按照本隐私政策来收集、使用、存储和保护您的相关信息。</div>
      <div>一、适用范围 </div>
      <div>&emsp;&emsp;1. 除某些特定产品和服务外，本隐私政策适用于云学谷提供的所有服务。这些特定产品和服务将适用特定的隐私政策。</div>
      <div>&emsp;&emsp;2. 需要特别说明的是，本隐私政策也不适用于其他第三方向您提供的服务。包括但不限于下述情形：</div>
      <div>&emsp;&emsp;（1） 通过我们的产品和服务而接入的第三方服务（包括任何第三方网站）收集的信息；</div>
      <div>&emsp;&emsp;（2） 通过在我们的产品和服务中进行广告服务的其他公司或机构所收集的信息。请你知悉：如果您浏览第三方网站或使用第三方产品、服务时向其提供个人信息，则您的信息应当适用该第三方的隐私政策，我们不承担任何法律责任，请您届时务必仔细阅读该第三方的隐私政策并确认是否接受。</div>
      <div>二、我们收集哪些信息 </div>
      <div>&emsp;&emsp;为了向您提供更好、更优、更个性化的服务，我们将根据您使用的服务收集您的如下信息：</div>
      <div>&emsp;&emsp;1. 您注册或登录的账户信息，例如您注册、登录云学谷账户使用的电话号码，用户自行填写的姓名或昵称、班级、年级、学校、性别、出生日期、身份、入学年份等；</div>
      <div>&emsp;&emsp;2. 您自行上传的信息，例如您的发帖、评论、分享，主动填写的信息或您与云学谷客服联系时提供的相关信息等；</div>
      <div>&emsp;&emsp;3. 您使用云学谷过程中产生的信息。公司会根据您授予的权限，接收并记录您所使用的设备相关信息，包括设备属性信息（如设备型号、操作系统版本、设备设置、唯一设备标识符等软硬件特征信息）、设备位置信息（如通过GPS、蓝牙或WIFI信号获得的位置信息）、设备连接信息（如IP地址、电信运营商、访问日期和时间等）等；</div>
      <div>&emsp;&emsp;4. 您在云学谷购买需要邮寄的产品时或者参加我们有关的市场营销活动时提供的姓名、通信地址、联系方式等；</div>
      <div>&emsp;&emsp;5. 云学谷根据您的授权通过合法方式收集的其他个人信息。</div>
      <div>三、我们可能如何收集信息 </div>
      <div>&emsp;&emsp;我们或我们的第三方合作伙伴，可能通过cookies和web beacon收集和使用您的信息，并将该等信息储存为日志信息。我们使用自己的cookies和web beacon，目的是为您提供更个性化的用户体验和服务，并用于以下用途：</div>
      <div>&emsp;&emsp;1. 记住您的身份。例如：cookies和web beacon有助于我们辨认您作为我们的注册用户的身份，或保存您向我们提供的有关您的喜好或其他信息。</div>
      <div>&emsp;&emsp;2. 分析您使用我们服务的情况。例如，我们可利用cookies和web beacon来了解您使用我们的服务进行什么活动，或哪些服务最受您的欢迎。 </div>
      <div>&emsp;&emsp;3. 广告优化。Cookies和web beacon有助于我们根据您的信息，向您提供与您相关的广告而非进行普遍的广告投放。</div>
      <div>&emsp;&emsp;我们为上述目的使用cookies和web beacon的同时，可能将通过cookies和web beacon收集的非个人身份信息，经统计加工后提供给广告商或其他合作伙伴，用于分析用户如何使用我们的服务，并用于广告服务。</div>
      <div>&emsp;&emsp;我们的产品和服务上可能会有广告商或其他合作方放置的cookies和web beacon。这些cookies和web beacon可能会收集与您相关的非个人身份信息，以用于分析您如何使用该等产品或服务，向您发送您可能感兴趣的广告，或用于评估广告服务的效果。这些第三方cookies和web beacon收集和使用该等信息，不受本隐私政策约束，而是受相关第三方的隐私政策约束，我们不对此类cookies和web beacon承担责任。</div>
      <div>&emsp;&emsp;您可以通过浏览器设置拒绝或管理cookies。但请注意，如果停用cookies或web beacon，您有可能无法享受最佳的服务体验，某些产品或服务可能也无法正常使用。</div>
      <div>四、我们如何使用收集到的信息 </div>
      <div>&emsp;&emsp;收集您的信息是为了向您提供服务及提升服务质量，为了实现这一目的，我们会把您的信息用于下列用途：</div>
      <div>&emsp;&emsp;1. 向您提供您使用的各项产品或服务；</div>
      <div>&emsp;&emsp;2. 帮助我们设计新产品或服务，改善现有的产品或服务；</div>
      <div>&emsp;&emsp;3. 在我们提供产品或服务时，用于身份验证、客户服务、安全防范、诈骗监测、存档和备份用途，确保我们向您提供的产品和服务的安全性；</div>
      <div>&emsp;&emsp;4. 帮助我们更加了解您使用我们产品和服务的情况，从而针对性的回应您的个性化需求，以便为您提供服务、个性化内容和建议。</div>
      <div>&emsp;&emsp;5. 向您推荐您可能感兴趣的内容，以及提供产品和服务的广告</div>
      <div>&emsp;&emsp;6. 评估广告和其他促销、推广活动的效果并加以改善；</div>
      <div>&emsp;&emsp;7. 经您许可的其他用途。</div>
      <div>五、我们如何共享或披露信息</div>
      <div>&emsp;&emsp;1. 我们会以高度的勤勉义务对待您的信息，除以下情形外，未经您同意，我们不会与任何第三方分享您的个人信息： 我们可能将我们按照本隐私政策收集的您的信息提供给我们的关联公司、合作伙伴或第三方服务提供方（比如代表我们发送短信的服务提供商），用作下列用途：</div>
      <div>&emsp;&emsp;（1）向您提供更好的客户服务和用户体验</div>
      <div>&emsp;&emsp;（2）实现我们收集、使用您的信息的目的；</div>
      <div>&emsp;&emsp;（3）行使和履行我们再用户协议、本隐私政策或平台其他规则中规定的我们的权利和义务；</div>
      <div>&emsp;&emsp;（4）理解、维护和改善我们的产品及服务。</div>
      <div>&emsp;&emsp;2. 我们不会非法出售、非法向他人提供您的信息；我们不会将您的该等信息提供给任何第三方，也不会用于任何其他目的和用途，但是以下情形除外：</div>
      <div>&emsp;&emsp;（1）经您事先同意，向第三方披露；</div>
      <div>&emsp;&emsp;（2）根据法律的有关规定，或者行政或司法机构的要求，向第三方或者行政、司法机构披露；</div>
      <div>&emsp;&emsp;（3）在我们提供服务时，可能将您的信息用于身份验证、客户服务、安全防范、诈骗监测、存档和备份等用途，以预防、发现、调查欺诈、危害安全、非法或违反与我们的协议、政策或规则的行为，以保护您、其他用户、我们的关联公司、合作伙伴及其他受信任的第三方供应商、服务商、代理商及社会公众的合法权益，以确保我们向您提供的产品和服务的安全性；</div>
      <div>&emsp;&emsp;（4）我们与第三方合作向您提供云学谷平台的相关服务或其他网络服务，且该等第三方同意承担与我们同等的保护用户隐私的责任；</div>
      <div>&emsp;&emsp;（5）其他根据法律、法规或者政策应进行的披露。</div>
      <div>六、您如何管理自己的信息及账号注销</div>
      <div>&emsp;&emsp;1. 您可以在个人账户中查询、更正、修改、删除您的个人信息</div>
      <div>&emsp;&emsp;2. 如果您决定停止使用云学谷的，则您可以对您的账号进行停用。</div>
      <div>七、我们如何存储您的信息</div>
      <div>&emsp;&emsp;我们在中华人民共和国境内运营中收集和产生的个人信息，原则上存储在中国境内，并按照中国中华人民共和国法律法规、部门规章等规定的存储期限存储您的个人信息。</div>
      <div>八、我们如何保护您的信息</div>
      <div>&emsp;&emsp;1. 我们非常重视您的个人信息安全。我们努力采取各种合理的物理、电子和管理方面的安全措施来保护您的个人信息，并尽最大合理努力使您的个人信息不会被泄漏、毁损或者丢失，包括但不限于SSL、信息加密存储、数据中心的访问控制。我们对可能接触到您个人信息的员工或外包人员也采取了严格管理，包括但不限于采取信息访问权限控制、与接触个人信息的人员签署保密协议、监控该等人员的操作情况等措施。</div>
      <div>&emsp;&emsp;2. 尽管有上述第1款的约定，但是请您理解并明白，由于存在各种各样无法预知或现有技术无法防御的恶意手段，即便我们已经尽力采取必要的保护措施，您的信息仍有可能被泄露、毁损或灭失。如您发现您的账号、密码因任何原因已经或者将要泄露时，您应当立即跟我们联系，以便我们可以及时采取应对措施防止或减少您的相关损失。</div>
      <div>&emsp;&emsp;3. 如果我们发生企业合并、分立等情形的，则您的信息将由届时存续的企业主体继续履行保护义务，并由我们以公告、短信或其他书面方式通知您；如果我们的产品、服务停止运营的，则我们将及时停止继续收集您的信息，并以公告、短信等方式通知您，届时我们将对您的信息进行删除或隐匿化处理。</div>
      <div>九、未成年人保护 </div>
      <div>&emsp;&emsp;我们重视未成年人的个人信息保护，如您为18周岁以下的未成年人，请在您的监护人指导下仔细阅读本隐私政策，并在征得您的监护人同意的前提下使用我们的服务及提交您的个人信息。如您的监护人不同意本隐私政策，您应立即停止使用云学谷的服务并拒绝提供个人信息。</div>
      <div>&emsp;&emsp;对于监护人同意而收集的未成人个人信息，我们仅会在法律法规允许、监护人明确同意或保护未成年人用户的范围内使用或披露该信息。对于未经监护人同意而未成年人用户提供的个人信息，在接到其监护人的通知后，我们会尽快删除相关信息。</div>
      <div>十、本政策的修订</div>
      <div>&emsp;&emsp;我们可不定期修改本隐私政策，变更后的隐私政策将在修订生效前通过云学谷平台公告或以其他适当方式通知您。该等情况下，若您继续使用我们的服务，即表示同意受经修订的隐私政策的约束。</div>
      <div>十一、争议管辖</div>
      <div>&emsp;&emsp;1. 本隐私政策的签订、生效、履行、争议的解决均适用中华人民共和国法律。</div>
      <div>&emsp;&emsp;2. 有关本协议的争议应通过友好协商解决，如果协商不成，该争议将提交公司所在地有管辖权的法院诉讼解决。</div>
      <div style="margin-top: 20px;">本隐私政策由北京腾骏英才教育科技有限公司制定并解释。</div>
      <div>如您有任何疑问或投诉、举报，您可以通过下述方式联系我们。</div>
      <div>地址：北京市朝阳区铁建广场E-1213</div>
      <div>邮箱：yunxuegu@163.com</div>
      <div>联系电话：400-877-0667</div>
      <div>北京腾骏英才教育科技有限公司对于本协议内容拥有最终解释权和修订权。</div>
      <span style="float:right;font-weight:bold">
        北京腾骏英才教育科技有限公司
      </span>
    </div>
  </a-modal>
</template>
<script>
export default {
  name: 'PrivacyModal',
  data () {
    return {
      vable: false
    }
  },
  methods: {
    payulan () {
      this.vable = true
    },
    handleOk () {
      this.vable = false
    }
  }
}
</script>

<style scoped>
</style>
